// ──────────────────────────────────────────────
// src/config.js
// Central place for values that come from .env.*
// Only vars starting with REACT_APP_ are exposed
// ──────────────────────────────────────────────
export const API_BASE =
  process.env.REACT_APP_API_URL || 'http://localhost:3001';
